var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-card"},[_c('button',{staticClass:"accordion"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"panel"},[_c('hr'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }